<div class="wide__page__container">
    <div class="top-bar">
        <h2>Release Information</h2>
        <button
                class="back__btn"
                (click)="close()"
                mat-icon-button
                aria-label="close"
        >
            <mat-icon class="action-icon">close</mat-icon>
        </button>
    </div>

    <div class="about-container"
        role="contentinfo">

        <div class="menu-left">
            @for(app of applications; track app) {
                <div class="menu-item ops-selectable-primary"
                     [class.active]="selectedApplication.value === app.value"
                     (click)="selectApplication(app.value)">
                    {{ app.label }}
                </div>
            }
        </div>

        <div class="content">
            @if (loading) {
                <div class="loading-container">
                    <mat-spinner diameter="50"></mat-spinner>
                </div>
            } @else if (changeLog) {
                @if(changeLog.content === '') {
                    <mat-hint>
                        <em>
                            No changelog available for this application.
                        </em>
                    </mat-hint>
                }
                <markdown ngPreserveWhitespaces>
                    {{ this.changeLog.content }}
                </markdown>
            }
        </div> <!-- end content -->

    </div> <!-- end about-container -->

</div> <!-- end wide__page__container -->
